<template>
  <v-snackbar
    :value="hasError"
    class="errorSnackBar"
    color="error"
    vertical
    multi-line
    bottom
    @input="close">

    <div v-for="(error, index) in errors"
         :key="error">
      <p v-if="index > 0">
        -
      </p>
      <p>{{ error }}</p>
    </div>

    <v-btn
      dark
      flat
      @click="close(false)">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { Component,  Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import { API_ERROR_SET } from '@/apps/core/store/types';


@Component
export default class ApiErrors extends Vue {
  @Getter apiError;
  @Action(API_ERROR_SET) setApiError;

  errors = [];
  timeoutId = null;

  @Watch('apiError', { immediate: true })
  onChangeApiError(error) {
    const errorMsg = error.detail;

    if (error.detail && !this.errors.includes(errorMsg)) {
      this.errors.push(errorMsg);
      this.setTimeout();
    }
  }

  /**
   * Close popup
   */
  close(value) {
    if (!value) {
      this.errors = [];
      this.setApiError({ detail: '' });
      clearTimeout(this.timeoutId);
    }
  }

  /**
   * Check errors
   */
  get hasError() {
    return this.errors.length;
  }

  /**
   * Set popup timeout.
   */
  setTimeout() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(this.close, 6000);
  }
}
</script>

<style lang="scss">
@import '@/style/variables.scss';

.errorSnackBar {
  z-index: 99999;
  color: white;
  text-align: center;

  p {
    color: $white;
    font-weight: 400;
  }

  .v-snack__content {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ApiErrors.vue